import produce from 'immer';
import { get, set } from 'lodash';

const EDIT_FIELD = 'EDIT_FIELD';
export const editField = (field, value) => {
  return {
    type: EDIT_FIELD,
    payload: { field, value }
  }
};

const ADD_FIELD = 'ADD_FIELD';
export const addField = (field, value) => ({
  type: ADD_FIELD,
  payload: { field, value },
});

const REMOVE_FIELD = 'REMOVE_FIELD';
export const removeField = (field) => ({
  type: REMOVE_FIELD,
  payload: { field },
});

const DELETE_ARRAY_ITEM = 'DELETE_ARRAY_ITEM';
export const deleteArrayItem = (field, index) => ({
  type: DELETE_ARRAY_ITEM,
  payload: { field, index },
});

const SET_FILE = 'SET_FILE';
export const setFile = (file) => ({
  type: SET_FILE,
  payload: { file },
});


const initialState = {
  root: [],
}

export const fileReducer = (state = initialState, { type, payload }) => {
  switch(type) {
    case EDIT_FIELD:
      return produce(state, draft => {
        set(draft, payload.field, payload.value);
      });
    case REMOVE_FIELD:
      return produce(state, draft => {
        set(draft, payload.field, undefined);
      });
    case ADD_FIELD:
      return produce(state, draft => {
        set(draft, payload.field, [...get(state, payload.field), payload.value]);
      });
    case DELETE_ARRAY_ITEM:
      return produce(state, draft => {
        set(draft, payload.field, [...get(state, payload.field).filter((x, i) => {
          return i !== payload.index;
        })]);
      })
    case SET_FILE:
      return payload.file;
    default:
      return state;
  }
}
